import { LocalStorageGenerator } from '../../utils';
import { ShippingFlags } from './ShippingView';

export const ShippingFlagsStore = LocalStorageGenerator<ShippingFlags>('ShippingFlags', {
  notCloseToDropoff: false,
  shippedUpsForCourierPreferred: false,
});
